import { render, staticRenderFns } from "./r-boat-kind.vue?vue&type=template&id=1f25e702"
import script from "./r-boat-kind.vue?vue&type=script&lang=js"
export * from "./r-boat-kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f25e702')) {
      api.createRecord('1f25e702', component.options)
    } else {
      api.reload('1f25e702', component.options)
    }
    module.hot.accept("./r-boat-kind.vue?vue&type=template&id=1f25e702", function () {
      api.rerender('1f25e702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/boats/r-boat-kind.vue"
export default component.exports